module.exports = __webpack_public_path__ + "img/p16_11.df45965c.png";